import {IWizardEmployment, IWizardIncome} from '../../../models/application-form'

export const createEmptyEmployment = (): IWizardEmployment => ({
  companyName: '',
  employmentType: '',
  startDate: null,
  isStartMonthUnknown: false,
  employerName: '',
  employerPhone: '',
  employerEmail: '',
  employerReference: '',
  abn: '',
  businessAddress: '',
  businessName: '',
  businessStructure: '',
  role: '',
  industryType: '',
  uniqueStudentIdentifier: '',
  additionalReferenceName: '',
  additionalReferencePhone: '',
  additionalReferenceEmail: '',
})

export const createEmptyIncome = (): IWizardIncome => ({
  hasEmploymentIncome: false,
  hasSelfEmploymentIncome: false,
  income: undefined,
  incomeFrequency: 'annually',
  selfEmploymentIncome: undefined,
  selfEmploymentIncomeFrequency: 'annually',
  isCentreLink: false,
  centreAmount: undefined,
  centreLinkFrequency: '',
  hasPension: false,
  pensionAmount: undefined,
  pensionFrequency: '',
  hasNdis: false,
  ndisAmount: undefined,
  ndisFrequency: '',
  hasStudentSupport: false,
  studentSupportAmount: undefined,
  studentSupportFrequency: '',
})
